import { render, staticRenderFns } from "./visa.vue?vue&type=template&id=a2b91ca2&scoped=true&"
import script from "./visa.vue?vue&type=script&lang=js&"
export * from "./visa.vue?vue&type=script&lang=js&"
import style0 from "./visa.vue?vue&type=style&index=0&id=a2b91ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b91ca2",
  null
  
)

export default component.exports